import { type User } from "@/lib/backend/api";

export function getFullName(user: User) {
	return [user.name, user.family].join(" ").trim();
}
